module.exports = __webpack_public_path__ + "static/media/BV.da6fb8dd.svg";